import type { BaseCommunityFragment } from "../generated/graphql"

export const communityIconUrl = (community: BaseCommunityFragment | undefined) =>
  community
    ? (community.iconUrl ??
      `${process.env.NEXT_PUBLIC_S3_URL || ""}/community/icon/${community.id}`)
    : ""

export const getCommunityIdBasedOnCode = (communities: BaseCommunityFragment[], code: string) => {
  let communityId = ""
  const community = communities.find((c) => c.code === code)
  if (community) communityId = community.id

  return communityId
}
